/**
 * @file 直播测试
 */
import { useEffect, useMemo } from 'react';
import VideoPlayer from './VideoPlayer';
import s from './index.module.css';
import { liveMenuList } from '@/core/constant';
import { generateParams, isMobile } from '@/utils';

const Live = () => {
  const { id } = generateParams() || {};
  const liveInfo = liveMenuList.find(item => item.id === id);

  useEffect(() => {
    document.title = liveInfo?.title || 'ICBS';
  }, []);

  const handleClickLogo = () => {
    window.open('https://www.icbs.cn/en/web/index/', '_blank');
  };

  const renderNav = useMemo(() => {
    return (
      <div className={s.nav}>
        {!isMobile && <div className={`${s.navItem} ${s.leftLogo}`} onClick={handleClickLogo} />}
        <div className={`${s.navItem} ${s.rightLogo}`} />
      </div>
    );
  }, [id, liveInfo]);

  return (
    <div className={`${s.container} ${isMobile ? s.mobile : ''}`}>
      {renderNav}
      <div className={s.title}>{liveInfo?.title || ''}</div>
      <div className={s.content}>
        <div className={s.video}>
          <VideoPlayer />
        </div>
        {isMobile && <div className={s.mobileLogo} />}
      </div>
    </div>
  );
};

export default Live;

// const handleLiveIdChange = (id: string) => {
//   redirectToNewId(id);
// };

// const renderMenu = useMemo(() => {
//   return (
//     <div className={`${s.menu} ${s.navItem}`}>
//       <span className={s.menuText} onClick={() => setIsShowMenu(isShow => !isShow)}>
//         {isShowMenu ? 'x 收起' : '目录'}
//       </span>
//       {isShowMenu && (
//         <div className={s.menuList}>
//           {liveMenuList.map(item => {
//             return (
//               <div
//                 className={`${s.menuItem} ${id === item.id ? s.checked : ''}`}
//                 key={item.id}
//                 onClick={handleLiveIdChange.bind(null, item.id)}
//               >
//                 {item.title}
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }, [isShowMenu, id]);
